import React from "react";

const KufiIcon = () => {
  return (
    <svg
      className=" absolute top-1/2 -translate-y-1/2 right-0"
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      width="28px"
      height="28px"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="#5fd068"
        opacity="0.5"
        stroke="none"
      >
        <path d="M2490 5108 c-27 -7 -114 -88 -370 -344 l-336 -334 -464 0 c-432 0 -468 -2 -505 -19 -53 -24 -83 -55 -106 -105 -17 -38 -19 -74 -19 -506 l0 -464 -334 -336 c-348 -349 -356 -359 -356 -440 0 -81 8 -91 356 -440 l334 -336 0 -464 c0 -431 2 -468 19 -505 10 -22 31 -52 47 -67 62 -58 62 -58 566 -58 l462 0 336 -334 c349 -348 359 -356 440 -356 81 0 91 8 440 356 l336 334 464 0 c432 0 468 2 506 19 51 23 90 64 110 116 12 34 14 87 12 314 l-3 273 -28 24 c-41 35 -99 33 -138 -5 l-29 -29 0 -256 0 -256 -487 0 -487 0 -348 -347 -348 -348 -348 348 -348 347 -487 0 -487 0 0 487 0 487 -347 348 -348 348 348 348 347 348 0 487 0 487 487 0 487 0 348 347 348 348 348 -348 348 -347 487 0 487 0 0 -487 0 -487 347 -348 348 -348 -186 -188 c-103 -103 -189 -198 -192 -211 -15 -63 56 -132 119 -117 31 8 390 356 425 412 26 42 34 109 19 164 -11 40 -48 81 -346 380 l-334 336 0 464 c0 432 -2 468 -19 505 -24 53 -55 83 -105 106 -38 17 -74 19 -506 19 l-464 0 -336 334 c-281 280 -341 336 -375 345 -48 13 -87 13 -135 -1z" />
        <path d="M4281 1906 c-89 -49 -49 -186 54 -186 36 0 95 59 95 94 0 80 -80 130 -149 92z" />
      </g>
    </svg>
  );
};

export default KufiIcon;
